import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class ProductionItemRequestActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/ItemRequest/ItemRequestBrowser")
	}

	render() {
		return (
			<Activity 
				name="ProductionItemRequest"
				RenderedComponent={this.RenderedComponent}
				context="center"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(ProductionItemRequestActivity)
